import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CriticsReviewsContainer } from './CriticsReviews';
import { StaffCommentsContainer } from './StaffComments';
import { CommunityCommentsContainer } from './CommunityComments';
import './Opinion.scss';

export default class Opinion extends React.PureComponent {
  render() {
    return (
      <section className="cp-bib-opinion container">
        <div className="row">
          <div className="col-lg-3">
            <h2>
              <FormattedMessage id="opinion_section" />
            </h2>
          </div>
          <div className="col-lg-7">
            <CriticsReviewsContainer />
            <StaffCommentsContainer />
            <CommunityCommentsContainer />
          </div>
        </div>
      </section>
    );
  }
}
